import { FormikProps, useFormik } from 'formik';
import React from 'react';
import { Button, Dialog, Grid } from 'src/components';
import DialogActions from 'src/components/DialogActions';
import DialogContent from 'src/components/DialogContent';
import DialogTitle from 'src/components/DialogTitle';
import NumberField from 'src/components/NumberField';
import ParametreGrupEnum from 'src/enums/ParametreGrupEnum';
import { translate } from 'src/i18n/tHelper';
import VwKurumbonustanimDTO from 'src/models/KurumBonusTanim/VwKurumbonustanimDTO';
import GnlParametreSelect from 'src/parts/Genel/gnl.parametre.select';
import KurumAutoComplete from 'src/parts/Kurum/kurum.autocomplete';
import { useKurumBonusTanimEkleMutation, useKurumBonusTanimGuncelleMutation } from 'src/services/KurumBonusTanimlari/KurumBonusTanimlariApi';
import { useAppDispatch, useAppSelector } from 'src/store';
import { kurumBonusTanimlariSlice } from 'src/store/Slices/KurumBonusTanimlari/KurumBonusTanimlariSlice';
import * as yup from 'yup';

const translatePath = "pages|kurumBonusTanimlari";
let formik: FormikProps<VwKurumbonustanimDTO> = null;
const KurumBonusTanimlariEkle = (): JSX.Element => {
    const state = useAppSelector(s => s.kurumBonusTanimlari);
    const dispatch = useAppDispatch();

    const [ekle, ekleState] = useKurumBonusTanimEkleMutation();
    const [guncelle, guncelleState] = useKurumBonusTanimGuncelleMutation();

    const handlerSave = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        if (!ekleState.isLoading && !guncelleState.isLoading)
            formik.submitForm();
    }
    const handlerClose = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        dispatch(kurumBonusTanimlariSlice.actions.setOpen(false));
    };
    formik = useFormik({
        enableReinitialize: true,
        initialValues: state.activeRow,
        validateOnChange: false,
        onSubmit: async (values) => {
            if (values?.id > 0) {
                await guncelle(values).unwrap().then(() => { handlerClose(null); }).catch(e => e);
                return;
            }
            await ekle(values).unwrap().then(() => { handlerClose(null); }).catch(e => e);
        },
        validationSchema: yup.object().shape({
            fkKurumId: yup.number().required(translate(translatePath, "Kurum alanı zorunludur.")),
            bonusYontem: yup.number().required(translate(translatePath, "Bonus Yöntem alanı zorunludur.")),
            oran: yup.number().required(translate(translatePath, "Oran alanı zorunludur.")).typeError(translate(translatePath, "Oran alanı zorunludur.")),
        }),
    });

    return (
        <Dialog fullWidth open={state.open} maxWidth="sm">
            <DialogTitle>{translate(translatePath, "Kurum Bonus Tanımı Ekle")}</DialogTitle>
            <DialogContent>
                <Grid container>
                    <Grid item>
                        <KurumAutoComplete
                            required
                            label={translate(translatePath, "Kurum")}
                            name="fkKurumId"
                            value={formik.values.fkKurumId}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.fkKurumId)}
                            helperText={formik.errors.fkKurumId}
                        />
                    </Grid>
                    <Grid item sm={6}>
                        <GnlParametreSelect
                            required
                            label={translate(translatePath, "Bonus Yöntem")}
                            parametreType={ParametreGrupEnum.KurumBonusYontem}
                            name="bonusYontem"
                            value={formik.values.bonusYontem}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.bonusYontem)}
                            helperText={formik.errors.bonusYontem}
                        />
                    </Grid>
                    <Grid item sm={6}>
                        <NumberField
                            required
                            allowNegative={false}
                            decimalScale={2}
                            label={translate(translatePath, "Oran")}
                            name="oran"
                            value={formik.values.oran}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.oran)}
                            helperText={formik.errors.oran}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button disabled={!formik.dirty} loading={ekleState.isLoading || guncelleState.isLoading} customType="save" onClick={handlerSave} />
                <Button customType="close" onClick={handlerClose} />
            </DialogActions>
        </Dialog>
    );
};

export default KurumBonusTanimlariEkle;